// extracted by mini-css-extract-plugin
export default {"error_main_container":"Error404Page_error_main_container__LwpmW"};